<template>
  <div class="select-page">
    <div class="select-page__intro">
      <div class="tabs-nav">
        <span
          :class="['_tab', viewType == 'list' ? 'active' : '']"
          @click="viewTypeChange('list')"
          >Списком</span
        >
        <span
          :class="['_tab', viewType == 'map' ? 'active' : '']"
          @click="viewTypeChange('map')"
          >Плиткой</span
        >
      </div>
    </div>

    <div :class="['aparts-select-tool', 'aparts-select-tool--' + viewType]">
      <transition name="tab">
        <DocumentsList v-if="viewType == 'list'" />
        <DocumentsGrid v-else-if="viewType == 'map'" />
      </transition>
    </div>
  </div>
</template>

<script>
import DocumentsList from "@/components/DocumentsList"
import DocumentsGrid from "@/components/DocumentsGrid"

export default {
  name: "Documents",
  data() {
    return {
      viewType: "list",
    }
  },
  mounted() {
    window.scrollTo(0, 0)
  },
  methods: {
    viewTypeChange(name) {
      this.viewType = name
    },
  },
  components: {
    DocumentsList,
    DocumentsGrid,
  },
}
</script>
